import TotalSkinContainer from "./TotalSkinContainer";

export default TotalSkinContainer;
